import React, { useState } from 'react';
import { User, Package, FileText, Gift, Settings } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

// Import existing components (we'll reuse them)
import MyOrders from './MyOrders';
import MyInvoices from './MyInvoices';
import MyCoupons from './MyCoupons';
import AccountSettings from '../components/AccountSettings';

const MyAccount = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      <div className="flex-1 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="mb-8">
            <h1 className="text-4xl font-bold mb-2">Mein Konto</h1>
            <p className="text-gray-600">Verwalten Sie Ihre Bestellungen, Rechnungen und Einstellungen</p>
          </div>

          {/* Tabs */}
          <Tabs defaultValue="orders" className="w-full">
            <TabsList className="grid w-full grid-cols-4 mb-8 h-auto">
              <TabsTrigger value="orders" className="flex items-center gap-2 py-3">
                <Package className="h-4 w-4" />
                <span className="hidden sm:inline">Bestellungen</span>
              </TabsTrigger>
              <TabsTrigger value="invoices" className="flex items-center gap-2 py-3">
                <FileText className="h-4 w-4" />
                <span className="hidden sm:inline">Rechnungen</span>
              </TabsTrigger>
              <TabsTrigger value="coupons" className="flex items-center gap-2 py-3">
                <Gift className="h-4 w-4" />
                <span className="hidden sm:inline">Coupons</span>
              </TabsTrigger>
              <TabsTrigger value="settings" className="flex items-center gap-2 py-3">
                <User className="h-4 w-4" />
                <span className="hidden sm:inline">Mein Konto</span>
              </TabsTrigger>
            </TabsList>

            <TabsContent value="orders">
              <MyOrders embedded={true} />
            </TabsContent>

            <TabsContent value="invoices">
              <MyInvoices embedded={true} />
            </TabsContent>

            <TabsContent value="coupons">
              <MyCoupons embedded={true} />
            </TabsContent>

            <TabsContent value="settings">
              <AccountSettings />
            </TabsContent>
          </Tabs>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default MyAccount;
